import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RemindersListComponent } from './components/reminders-list/reminders-list.component';

const routes: Routes = [
  {
    path: 'reminders-list',
    component: RemindersListComponent,
    title: 'Reminders List',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RemindersRoutingModule {}
